import { computed, inject, Injectable, signal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom, Observable, tap } from "rxjs";
import { IDropdownDefinition } from "@logex/framework/ui-core";
import { Tag } from "../types/tag";

@Injectable({ providedIn: "root" })
export class TagsService {
    private _http = inject(HttpClient);

    private _tags = signal<Tag[]>([]);

    readonly tags = this._tags.asReadonly();

    readonly dropdownDefinition = computed<IDropdownDefinition<string>>(() => ({
        groups: [
            {
                entries: this._tags().map(tag => ({
                    id: tag.name,
                    name: tag.name,
                    order: 0
                }))
            }
        ]
    }));

    loadTags(): Promise<Tag[]> {
        return firstValueFrom(this._fetchTags());
    }

    private _fetchTags(): Observable<Tag[]> {
        return this._http
            .get<Tag[]>("api/editor/tags")
            .pipe(tap(tags => this._tags.set(tags ?? [])));
    }
}
